;
var sprite = require("/tmp/build_133e1b25/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_SavePDF_265183f4ce5e4f625079cfb967633686\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <g> <rect x=\"31.638\" y=\"30.395\" width=\"36.726\" height=\"4.282\"/> <rect x=\"31.638\" y=\"43.403\" width=\"36.726\" height=\"4.281\"/> <rect x=\"31.638\" y=\"56.41\" width=\"36.726\" height=\"4.28\"/> <rect x=\"31.638\" y=\"69.416\" width=\"36.726\" height=\"4.281\"/> <path d=\"M21.392,17.26v69.574h57.216V17.26H21.392z M74.034,82.553H25.966V21.541h48.068V82.553z\"/> </g> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_SavePDF_265183f4ce5e4f625079cfb967633686");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_SavePDF.svg
// module id = 1414
// module chunks = 0